import apiClient from "./axios"

export const getAccountImporterPayments = async (params = {}) => {
  const response = await apiClient.get('/account-importer-payments', { params })
  return response.data
}

export const getAccountImporterPayment = async (id) => {
  const response = await apiClient.get(`/account-importer-payments/${id}`)
  return response.data
}

export const createAccountImporterPayment = async (payload) => {
  const response = await apiClient.post('/account-importer-payments', payload)
  return response.data
}

export const updateAccountImporterPayment = async (id, payload) => {
  const response = await apiClient.patch(`/account-importer-payments/${id}`, payload)
  return response.data
}

export const deleteAccountImporterPayment = async (id) => {
  const response = await apiClient.delete(`/account-importer-payments/${id}`)
  return response.data
}
